
function waitForElm(selector) {
  return new Promise(resolve => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver(mutations => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
}

function waitForElms(selector) {
  return new Promise(resolve => {
    if (document.querySelectorAll(selector)) {
      return resolve(document.querySelectorAll(selector));
    }

    const observer = new MutationObserver(mutations => {
      if (document.querySelectorAll(selector)) {
        resolve(document.querySelectorAll(selector));
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
}

const stickyCartThreshold = parseInt('100');

function addScrollListener() {
  const stickyAddToCart = document.querySelector('.sticky-cartbtn');

  // show button after x pixels of scrolling
  window.addEventListener('scroll', () => {
    var var2 = Math.round((window.scrollY)/(document.documentElement.scrollHeight - window.innerHeight) * 100);

    if (stickyAddToCart) {
      if (var2 > stickyCartThreshold) {
        stickyAddToCart.classList.remove('hide');
      } else {
        stickyAddToCart.classList.add('hide');
      }
    }
  });
}

(async () => {
  addScrollListener();

  const imagePickers = document.querySelectorAll('.variant-image-picker');

  if (imagePickers) {
    imagePickers.forEach(imagePicker => {
      imagePicker.addEventListener('change', (e) => {
        if (e.target.value) {
          var value = document.getElementById(`${imagePicker.dataset.sectionId}-value`);
          if (value) value.innerHTML = e.target.value;
        }

        // Get variant ID from URL if present
        const urlParams = new URLSearchParams(window.location.search);
        const variantId = urlParams.get('variant');
        if (variantId) {
          // Use variant ID from URL
          console.log('Selected variant id:', variantId);
          const featureBlocks = document.querySelectorAll('.product-section-feature-block');
          featureBlocks.forEach(featureBlock => {
            const variantConditionId = featureBlock.dataset.variantConditionId;
            if (variantConditionId.length > 0) {
              if (variantConditionId == variantId) {
                featureBlock.classList.remove('hide');
              } else {
                featureBlock.classList.add('hide');
              }
            } 
          });
        }
      });
    })
  }

  /*document.addEventListener('pointerdown', async () => {
    var my = await waitForElm('[class^="styles_BundleProperties__toggleButton"]');
    if (my) {
      my.classList.add('hide');

      return;

      if (my.innerHTML.includes('Show')) {
        my.innerHTML = my.innerHTML.replaceAll(/Show \d+ items/g, "Zeige alle Produkte");
      }

      if (my.innerHTML.includes('Hide')) {
        my.innerHTML = my.innerHTML.replaceAll(/Hide \d+ items/g, "Produkte verbergen");
      }

    }
  });*/

  // add variant preview
  const register = () => {
    const variantButtons = document.querySelectorAll("[data-variant-preview]");
    variantButtons.forEach(button => {
      const clickaction = () => {
        const product = document.querySelectorAll(".grid-product[data-product-id='"+button.dataset.productId+"']");
        for (let element of product) {
          const img = element.querySelector('.primary-image-product')
          if (img) {
            img.srcset = "";
            img.src = button.dataset.variantImage;
          }

          // override href of grid item
          const linkElemements = element.querySelectorAll('a[data-product-link]');
          for (let linkElemen of linkElemements) {
            if (linkElemen.href) {
              if (linkElemen.href.includes('?variant=')) {
                linkElemen.href = linkElemen.href.slice(0, linkElemen.href.indexOf('?variant=')) + "?variant="+button.dataset.variantId;
              } else {
                linkElemen.href = linkElemen.href + "?variant="+button.dataset.variantId;
              }
            }
          }
        }

      }

      button.removeEventListener('click', clickaction);
      button.addEventListener('click', clickaction);
    })
  }

  register();

  setTimeout(() => {
    const slickButtons = document.querySelectorAll(".slick-arrow");
    slickButtons.forEach(button => {
      button.addEventListener('click', () => {
        register();
      });
    });
  }, 500);



  try {
    var my = await waitForElm('.loox-rating-label');
    var headertext = document.getElementById('testimonial_header_text');
    if (headertext) {
      var first = my.innerHTML.split('(')[1];
      headertext.innerText = first.slice(0, first.length - 1) + ' Bewertungen';
    }
  } catch (e) {
    // ignore
  }
})();

(function startEarlyBirdCountDown() {
  const elements = document.querySelectorAll("#EarlyBirdTime");
  if (!elements) return;

  elements.forEach(element => {
    const { date, midnight } = element.dataset;
    let parsedDate = new Date(parseInt(date));

    if (midnight === 'true') {
      const now = new Date();
      parsedDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999);
    }

    const x = setInterval(() => {
      const countDownDate = parsedDate.getTime();
      const now = new Date().getTime();
      const distance = countDownDate - now;

      const hours = Math.floor(distance / (60*60*1000));
      const hoursms = distance % (60*60*1000);
      const minutes = Math.floor(hoursms / (60*1000));
      const minutesms = distance % (60*1000);
      const seconds = Math.floor(minutesms / (1000));

      // const dayE = element.querySelectorAll("#EarlyBirdTimeDays");
      const hourE = element.querySelectorAll("#EarlyBirdTimeHours");
      const minuteE = element.querySelectorAll("#EarlyBirdTimeMinutes");
      const secondE = element.querySelectorAll("#EarlyBirdTimeSeconds");
      if (!hourE || !minuteE || !secondE) {
        clearInterval(x);
        return;
      }

      // dayE.forEach(elem => elem.innerHTML = days + " Tagen");
      hourE.forEach(elem => elem.innerHTML = hours.toString() + ' Std.'); // .padStart(2, '0')
      minuteE.forEach(elem => elem.innerHTML = minutes.toString() + ' Min.'); // .padStart(2, '0')
      secondE.forEach(elem => elem.innerHTML = seconds.toString() + ' Sek.'); // .padStart(2, '0')

      if (distance <= 0) {
        element.innerHTML = "Timer abgelaufen";
      }

      element.classList.remove('hide');
    }, 1000);
  });
})();

(async function insertLockSmithplace() {
  
  const element = await waitForElm("#locksmith_passcode");
  element.placeholder = 'Shop Passwort eingeben...';
})();

(async function addButtonListener() {
  
  // alle changes der ersten option überwachen
  /*const elements = await waitForElms("[data-quantity-option-1]");
  console.log('elements', elements);
  elements.forEach(element => {
    element.addEventListener('change', (e) => {
      // apply change to native form
      const nativeSelect = document.querySelector('[data-product-select]');
      if (nativeSelect) {
        // Get all options from native select
        const options = nativeSelect.querySelectorAll('option');
        
        // Find option with matching value from changed element
        const matchingOption = Array.from(options).find(option => option.value === e.target.value);
        
        if (matchingOption) {
          // Update the select value directly
          nativeSelect.value = e.target.value;
          
          // Create and dispatch both change and input events
          const changeEvent = new Event('change', { bubbles: true });
          const inputEvent = new Event('input', { bubbles: true }); 
          
          nativeSelect.dispatchEvent(inputEvent);
          nativeSelect.dispatchEvent(changeEvent);
        }
      }

    });
  });*/
  const cartBtn = await waitForElm("[data-add-to-cart]");
  // console.log('cartBtn', cartBtn);
  // Use delegated, capture-phase listener to survive node replacements and stopImmediatePropagation
  document.addEventListener('click', async (e) => {
    const targetButton = e.target && e.target.closest('[data-add-to-cart]');
    if (!targetButton) return;
    e.preventDefault();
    // console.log('cartBtn clicked', targetButton, e);

    // Get the quantity picker and find active option
    const quantityPicker = document.querySelector('.quantity-picker');
    if (quantityPicker) {
      e.stopPropagation();
      const activeOption = quantityPicker.querySelector('.quantity-option[data-active="true"]');
      if (activeOption) {
        const quantity = activeOption.getAttribute('data-value');
        // console.log('Selected quantity:', quantity);

        const items = [];

        // get the variants per pick
        const variants = document.querySelectorAll('[data-quantity-picker-'+quantity+']');
        const varaintsAr = [...variants];
        // varaintsAr.shift();
        varaintsAr.forEach(variant => {

          const fieldSet = quantityPicker.querySelector('fieldset');
          if (fieldSet && fieldSet.dataset.productId && fieldSet.dataset.sectionId) {
            // console.log('fieldset found', fieldSet, );

            // trigger buy via ajax add
            items.push({
              quantity: "1",
              form_type: "product",
              utf8: "✓",
              id: variant.value,
              product_id: fieldSet.dataset.productId,
              section_id: fieldSet.dataset.sectionId,
            });
          }
        });

        try {
            if (items.length) {
              // console.log('fetch with', items)
              const res = await fetch(theme.routes.cartAdd + '', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  items: items
                }),
              });

              e.stopPropagation();
            }
          } catch (e) {
            console.log(e);
          }
      }
    }
  }, { capture: true });
})();

(async function watchQuantityPicker() {
  const element = await waitForElm('.quantity-picker fieldset');
  element.addEventListener('click', (e) => {
    const activeOption = element.querySelector('.quantity-option[data-active="true"]');
    if (activeOption) {
      // get price
      const price = activeOption.querySelector('.price-tag-sale')?.innerHTML;
      const priceCompare = activeOption.querySelector('.price-tag-compare')?.innerHTML;

      const priceBox = document.querySelector('.product-block--price-box');
      if (priceBox) {
        try {
          priceBox.querySelector('[data-compare-price]').innerHTML = priceCompare;
        } catch (e) {
          console.log(e);
        }
        try {
          priceBox.querySelector('[data-product-price]').innerHTML = price;
        } catch (e) {
          console.log(e);
        }
      }
    }
  });
})();

(async function timerForOfferReasoning() {
  const elem = await waitForElm('.offer-reasoning-box');

  const countdownElement = elem.querySelector('.offer-reasoning-box__countdown');
  if (!countdownElement) return;
  
  // Immer bis zur nächsten Mitternacht zählen, unabhängig von gesetztem Datum
  function getNextMidnightTimestamp() {
    const nowTime = new Date().getTime();
    let targetTime;
    
    // Prüfe ob data-countdown-end gesetzt ist
    const countdownEndElement = elem.querySelector('[data-countdown-end]');
    if (countdownEndElement && countdownEndElement.dataset.countdownEnd && !isNaN(parseInt(countdownEndElement.dataset.countdownEnd))) {
      // Verwende das gesetzte Datum
      targetTime = parseInt(countdownEndElement.dataset.countdownEnd);
    } else {
      // Fallback: Bis zur nächsten Mitternacht
      const now = new Date();
      let target = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999).getTime();
      if (now.getTime() >= target) {
        target = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 23, 59, 59, 999).getTime();
      }
      targetTime = target;
    }

    let distance = targetTime - nowTime;
    
    // Stelle sicher, dass distance nicht negativ ist
    if (distance < 0) {
      distance = 0;
    }
    
    const hours = Math.floor(distance / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);
    
    return [hours, minutes, seconds];
  }
  
  function updateCountdown() {
    let [hours, minutes, seconds] = getNextMidnightTimestamp();
        
    const hoursEl = countdownElement.querySelector('[data-hours]');
    const minutesEl = countdownElement.querySelector('[data-minutes]');
    const secondsEl = countdownElement.querySelector('[data-seconds]');
    
    if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
    if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
    if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');
  }
  
  updateCountdown();
  setInterval(updateCountdown, 1000);
})();